import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import api from './api'
import widget from './widget'
import calendarWidget from './calendar-widget'
import auth from './auth'
import filters from './filters'
import rentalPeriods from './modules/rentalPeriods'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    api,
    widget,
    calendarWidget,
    auth,
    filters,
    rentalPeriods,
  },
  strict: process.env.DEV,
  plugins: [
    createPersistedState({
      paths: ['filters.forms'],
    }),
  ],
})
